import AbandonedCall from '../abandoned_call';
import CallForward from '../call_forward';
import ChatCustomerUrl from '../chat_customer_url';
import ChatEnded from '../chat_ended';
import ChatMessage from '../chat_message';
import ChatSelfServiceMetadata from '../chat_self_service_metadata';
import ContentPlaceholder from '../content_placeholder';
import ConversationItemType from '../conversation_item_type';
import ConversationMessage from '../conversation_message';
import ConversationNote from '../conversation_note';
import ConversationStatusChange from '../conversation_status_change';
import ConversationTopicChange from '../conversation_topic_change';
import CustomerActivity from '../customer_activity';
import CustomerAssigneeChange from '../customer_assignee_change';
import EmailMessage from '../email_message';
import EmailPreview from '../content_preview/email_preview';
import EmailSendFailure from '../email_send_failure';
import FbMessageIncoming from '../fb_message_incoming';
import FbMessageOutgoing from '../fb_message_outgoing';
import HelpAppContext from '../help_app_context';
import HotelReservation from '../hotel_reservation';
import ItemLinkContent from '../item_link_content';
import MarketingEmail from '../marketing_email';
import MessagingSession from '../messaging_session';
import MobileContext from '../mobile_context';
import Narvar from '../narvar';
import NoReplyNeeded from '../no_reply_needed';
import PaymentStatusEventContent from '../payment_status_event_content';
import PhoneCall from '../phone_call';
import PhoneCallback from '../phone_callback';
import ProactiveChatContent from '../proactive_chat_content';
import RoutingItem from '../routing_item';
import RuleDisabledLoop from '../rule_disabled_loop';
import SecureDataRequest from '../secure_data_request';
import SessionEnded from '../session_ended';
import SmsMessage from '../sms_message';
import Task from '../task';
import TaskCompletionContent from '../task_completion_content';
import TaskDueContent from '../task_due_content';
import TaskEditedContent from '../task_edited_content';
import TaskReopenedContent from '../task_reopened_content';
import TaskRouting from '../task_routing';
import Tweet from '../tweet';
import VoiceCampaignOutreach from '../voice_campaign_outreach';
import VoiceCampaignOutreachResult from '../voice_campaign_outreach_result';
import VoiceRecordingDeleted from '../voice_recording_deleted';
import Voicemail from '../voicemail';
import WebContext from '../web_context';
import WebForm from '../web_form';

export default [
  [ConversationItemType.ABANDONED_CALL, AbandonedCall],
  [ConversationItemType.CALL_FORWARD, CallForward],
  [ConversationItemType.CHAT_CUSTOMER_URL, ChatCustomerUrl],
  [ConversationItemType.CHAT_SELF_SERVICE_METADATA, ChatSelfServiceMetadata],
  [ConversationItemType.CHAT_ENDED, ChatEnded],
  [ConversationItemType.CHAT_MESSAGE, ChatMessage],
  [ConversationItemType.CONVERSATION_MESSAGE, ConversationMessage],
  [ConversationItemType.CONVERSATION_NOTE, ConversationNote],
  [ConversationItemType.CONVERSATION_STATUS_CHANGE, ConversationStatusChange],
  [ConversationItemType.CUSTOMER_ASSIGNEE_CHANGE, CustomerAssigneeChange],
  [ConversationItemType.EMAIL_PREVIEW, EmailPreview],
  [ConversationItemType.EMAIL_SEND_FAILURE, EmailSendFailure],
  [ConversationItemType.EMAIL, EmailMessage],
  [ConversationItemType.CUSTOMER_ACTIVITY, CustomerActivity],
  [ConversationItemType.FB_MESSAGE_INCOMING, FbMessageIncoming],
  [ConversationItemType.FB_MESSAGE_OUTGOING, FbMessageOutgoing],
  [ConversationItemType.HELP_APP_CONTEXT, HelpAppContext],
  [ConversationItemType.HOTEL_RESERVATION, HotelReservation],
  [ConversationItemType.NARVAR, Narvar],
  [ConversationItemType.ITEM_LINK, ItemLinkContent],
  [ConversationItemType.MARKETING_EMAIL, MarketingEmail],
  [ConversationItemType.MESSAGING_SESSION, MessagingSession],
  [ConversationItemType.MOBILE_CONTEXT, MobileContext],
  [ConversationItemType.NO_REPLY_NEEDED, NoReplyNeeded],
  [ConversationItemType.PAYMENT_STATUS_EVENT, PaymentStatusEventContent],
  [ConversationItemType.PHONE_CALL, PhoneCall],
  [ConversationItemType.PHONE_CALLBACK, PhoneCallback],
  [ConversationItemType.PROACTIVE_CHAT_CONTENT, ProactiveChatContent],
  [ConversationItemType.PLACEHOLDER, ContentPlaceholder],
  [ConversationItemType.ROUTING_ITEM, RoutingItem],
  [ConversationItemType.RULE_DISABLED_LOOP, RuleDisabledLoop],
  [ConversationItemType.SECURE_DATA_REQUEST, SecureDataRequest],
  [ConversationItemType.SESSION_ENDED, SessionEnded],
  [ConversationItemType.SMS, SmsMessage],
  [ConversationItemType.TASK, Task],
  [ConversationItemType.TASK_COMPLETION, TaskCompletionContent],
  [ConversationItemType.TASK_DUE, TaskDueContent],
  [ConversationItemType.TASK_EDITED, TaskEditedContent],
  [ConversationItemType.TASK_ROUTING, TaskRouting],
  [ConversationItemType.TASK_REOPENED, TaskReopenedContent],
  [ConversationItemType.TOPIC_CHANGE, ConversationTopicChange],
  [ConversationItemType.TWITTER, Tweet],
  [ConversationItemType.VOICEMAIL, Voicemail],
  [ConversationItemType.VOICE_CAMPAIGN_OUTREACH, VoiceCampaignOutreach],
  [ConversationItemType.VOICE_CAMPAIGN_OUTREACH_RESULT, VoiceCampaignOutreachResult],
  [ConversationItemType.VOICE_RECORDING_DELETED, VoiceRecordingDeleted],
  [ConversationItemType.WEB_CONTEXT, WebContext],
  [ConversationItemType.WEB_FORM, WebForm],
];



// WEBPACK FOOTER //
// ./src/scripts/domain/models/conversation_item/content_classes.js